module.exports = __webpack_public_path__ + "img/weaterStation.e1ca282a.png";